<!-- Popup thông tin nhà phát hành -->
<div class="modal-content">

  <!-- Modal Header -->
  <div class="modal-header">
    <div class="row">
      <div class="col-6">
        <label>{{'issuer.name_bond' | translate}}</label>
      </div>
      <div class="col-6">
        <label class="float-right">{{issuer.shortName}}</label>
      </div>
    </div>
    <button type="button" class="close" (click)="dismiss()">
      <img title="Close" src="https://s3-ap-southeast-1.amazonaws.com/finanma-static/assets/images/icon/close.png">
    </button>
  </div>

  <!-- Modal body -->
  <div class="modal-body">
    <div class="row modal-row">
      <div class="col-12">
        <div class="row">
          <div class="col-4 col-sm-5 tt-buy-hgt">
            <label>{{'issuer.full_name' | translate}}</label>
          </div>
          <div class="col-8 col-sm-7 text-right tt-buy-hgt">
            <label class="label-name">{{issuer.name}}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-4 col-sm-5 tt-buy-hgt">
            <label>{{'issuer.address' | translate}}</label>
          </div>
          <div class="col-8 col-sm-7 text-right tt-buy-hgt">
            <label class="label-name">{{issuer.address || issuer.address1}}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>